import React from 'react';
import { connect } from 'react-redux';
import { fetchSellers, setFiltroSeller } from '../../actions/sellersActions';
import { setTiposPublicacion } from '../../actions/tiposPublicacionActions';
import { limpiarFiltros } from '../../actions/generalActios';
import SellerListItem from './SellerListItem';
import FiltroSellers from './FiltroSellers';
import ReactPaginate from 'react-paginate';
import BtnToggleFilter from '../General/Filter/BtnToggleFilter';
import BigSpinner from '../General/BigSpinner';


class ListSellers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            onFilter: false,
            razonSocial: "",
            perPage: 10,
            currentPage: 1,
            hideLoader: false,
            hideNoHayPublicaciones: false
        };
        this.handlePageClick = this
            .handlePageClick
            .bind(this);        
    }

    handlePageClick = (e) => {

        this.setState({ hideLoader: false });
        const selectedPage = e.selected + 1;
        this.props.fetchSellers(
            this.state.razonSocial,
            this.state.perPage,
            selectedPage
        );
    };

    componentDidMount() {

        if (this.props.emptyFiltro.sellers && this.props.tipoUsuario === 2) {
            this.buscarSinFiltro();
        } else {
            this.buscarConFiltro();
        }
    }

    componentWillReceiveProps(futureProps) {

        if (!this.state.hideLoader) {
            this.setState({ hideLoader: true });
        }

        if (futureProps.sellers.length > 0 && this.state.hideNoHayPublicaciones) {
            this.onSellerChange(futureProps.sellers.length);
        }
    }

    buscarSinFiltro = () => {
        this.props.fetchSellers(
            this.state.razonSocial,
            this.state.perPage,
            this.state.currentPage
        );
    }

    buscarConFiltro = () => {

        this.props.fetchSellers(
            this.props.filtroSeller.razonSocial ?? "", 
            this.state.perPage,
            this.state.currentPage
        );
    }
  
    onSeller = (seller) => {
        this.props.setTiposPublicacion([{}]);
        this.props.history.push(`/Sellers/Editar/${seller.codigo}`);
    }

    goToSellerNuevo = () => {
        this.props.setTiposPublicacion([{}]);  
        this.props.history.push(`/Sellers/Nuevo`);
    }

    goToUserNuevo = () => {
        this.props.history.push(`/Usuarios/NuevoUser`);
    }

    goToEditProfile = () => {
        this.props.setTiposPublicacion([{}]);
        this.props.history.push(`/Sellers/Editar/${this.props.idSeller}`);
    }

    setFilter = (e) => {
        e.preventDefault();
        this.setState({ onFilter: !this.state.onFilter });
    }

    updateText = (text) => {
        this.props.setFiltroSeller({ razonSocial: text });
        this.setState({ razonSocial: text });
    }

    onSellerChange = (cantidadPublicaciones) => {
        if (cantidadPublicaciones > 0) this.setState({ hideNoHayPublicaciones: true });
        else this.setState({ hideNoHayPublicaciones: false });
    }

    
    render() {

        let sellers = this.props.sellers;
        let elementos = sellers.elementos === undefined ? [] : sellers.elementos;
        const isSeller = this.props.tipoUsuario !== 1 && this.props.tipoUsuario !== 2;

        return (
            <div>
                <div className="row align-items-center justify-content-between page-titles">

                    <div className="col-12 col-sm-5">
                        <h3 className="text-themecolor color-rojo-megatone">{this.props.userName}</h3>
                    </div>

                    <div className="button-group col-12 col-sm-7 mt-2 mt-sm-0 text-end">

                        <button
                            hidden={isSeller}
                            type="button"
                            onClick={() => this.goToSellerNuevo()}
                            className="btn btn-sm btn-green"
                        >
                            <i className="fa fa-plus-circle"/> Crear Seller Admin
                        </button>

                        <button
                            hidden={this.props.tipoUsuario !== 2 && this.props.tipoUsuario !== 3}
                            type="button"
                            className="btn btn-sm btn-green"
                            onClick={() => this.goToUserNuevo()}
                        >
                            <i className="fa fa-plus-circle mx-1"/>
                            {this.props.tipoUsuario === 2 ? "Crear Moderador" : "Crear usuario"}
                        </button>

                        <button 
                            type="button" 
                            onClick={() => this.goToEditProfile()} 
                            className="btn btn-sm background-rojo-megatone"
                        >
                            <i className="bi bi-pencil-fill"/> Mi perfil
                        </button>

                        <BtnToggleFilter
                            show={this.state.onFilter}
                            handleShow={() => this.setState({ onFilter: !this.state.onFilter })}
                        />

                    </div>
                </div>

                <div className="col-12" hidden={isSeller || !this.state.onFilter}>
                    <FiltroSellers updateText={this.updateText}/>
                </div>

                <div hidden={ !this.state.hideNoHayPublicaciones}>
                    <h5 className="d-flex justify-content-center m-t-40 m-b-40"> No hay sellers</h5>
                </div>

                <div hidden={this.state.hideLoader}>
                    <BigSpinner/>
                </div>

                <ul className="list-group">
                {
                    elementos.length > 0 ? elementos.map((seller, index) => {
                        return (
                            <a key={index} onClick={() => { this.onSeller(seller) }}>
                                <SellerListItem 
                                    codigoPostal={seller.codigoPostal}
                                    key={index}
                                    id={seller.codigo}
                                    razonSocial={seller.razonSocial}
                                    cuit={seller.cuit}
                                    telefono={seller.telefono}
                                    estado={seller.estado}
                                    contactoComercial={seller.email}
                                    emailContacto={seller.emailDespacho}
                                    direccion={seller.domicilio}
                                    numeroDomicilio={seller.numeroDomicilio}
                                    localidad={seller.localidad}
                                    provincia={seller.provincia}
                                /> 
                            </a>
                        )
                    }) : null
                }
                </ul>

                <div className="d-flex justify-content-center">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={this.props.sellers.cantidadTotal / this.state.perPage}
                        marginPagesDisplayed={10}
                        pageRangeDisplayed={this.state.perPage}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} 
                        forcePage={0}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    sellers: state.sellers.sellers,
    filtroSeller: state.sellers.filtro,
    userName: state.general.userName,
    idSeller: state.general.idSeller,
    emptyFiltro: state.general.limpiar,
    tipoUsuario: state.general.tipoUsuario
});

export default connect(mapStateToProps, { 
    fetchSellers,
    limpiarFiltros,
    setFiltroSeller, 
    setTiposPublicacion
}) (ListSellers);